import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function EventPostSuccessPage() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('event_id');

  return (
    <div data-testid="event-post-success-page" className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle className="w-16 h-16 mx-auto text-[#56dfb4] mb-4" />
        <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Event Published!</h1>
        <p className="text-slate-500 mb-6">Your event is now live on the Events board.</p>
        <div className="flex gap-3 justify-center">
          {eventId && (
            <Link to={`/events/${eventId}`}>
              <Button className="rounded-full bg-[#56dfb4] text-slate-900 hover:bg-[#3ec49b] px-6" data-testid="view-published-event">View Your Event</Button>
            </Link>
          )}
          <Link to="/events">
            <Button variant="outline" className="rounded-full px-6">Browse Events</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
